import type { AlpineComponent } from 'alpinejs';
import setDetailsHeight from '../../accordion/helper/setDetailsHeight';

const startAngles = [0, 45, -45];

let nextAngle = 0;

type AccordionTeaserData = {
  visible: boolean;
  activeIndex: number;
  anim: SVGRectElement | null;
  details: NodeListOf<HTMLDetailsElement> | [];
  setHeight: (detail: HTMLDetailsElement) => void;
  togglePanel: (e: MouseEvent) => void;
};

const AccordionTeaser = (): AlpineComponent<AccordionTeaserData> => ({
  visible: false,
  activeIndex: 1,
  anim: null,
  details: [],
  setHeight(detail: HTMLDetailsElement) {
    setDetailsHeight(detail);
    this.details[0].open = true;
  },
  togglePanel(e: MouseEvent) {
    e.preventDefault();
    const panel = (e.target as HTMLElement).closest('details');
    this.details.forEach((detail: HTMLDetailsElement, i: number) => {
      this.$root.style.maxHeight = `${this.$root.offsetHeight}px`;
      if (panel === detail) this.activeIndex = i + 1;
      detail.open = false;
    });
    panel && (panel.open = true);
    setTimeout(() => {
      this.$root.removeAttribute('style');
    }, 300);

    const angle = startAngles[nextAngle++ % startAngles.length];
    if (this.anim) {
      this.anim.style.transform = `rotate(${angle}deg) scaleY(var(--scale))`;
    }
  },
  init() {
    this.anim = this.$root.querySelector('.balance-mask__anim');
    if (this.anim) {
      this.anim.style.transform = `rotate(-45deg) scaleY(var(--scale))`;
    }

    this.details = this.$root.querySelectorAll('details');
    this.details[0].open = true;

    document.fonts.ready.then(() => {
      this.details?.forEach((detail: any) => this.setHeight(detail));
    });
  }
});

export default AccordionTeaser;
